import { render, staticRenderFns } from "./ServiceCategoryTabItem.vue?vue&type=template&id=0faa70e4&scoped=true&"
import script from "./ServiceCategoryTabItem.vue?vue&type=script&lang=ts&"
export * from "./ServiceCategoryTabItem.vue?vue&type=script&lang=ts&"
import style0 from "./ServiceCategoryTabItem.vue?vue&type=style&index=0&id=0faa70e4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0faa70e4",
  null
  
)

export default component.exports